import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { ShopPage } from '../../api/api-types';
import type { Loadable } from '../../guards/ngrx-loader.guard';
import { actions } from './shop.actions';

interface ShopState {
    content: Loadable<ShopPage>;
}

const initialState: ShopState = {
    content: null,
};

export const state = createFeature({
    name: 'shop',
    reducer: createReducer(
        initialState,
        on(
            actions.loadDealerShopSuccess,
            (state, { shop }): ShopState => ({
                ...state,
                content: shop,
            }),
        ),
        on(
            actions.loadDealerShopFailure,
            (state): ShopState => ({
                ...state,
                content: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingContent = createSelector(baseSelectors.selectContent, (content) => content === null);
        const selectLoadedContent = createSelector(baseSelectors.selectContent, (content) => content as ShopPage);

        return {
            selectIsLoadingContent,
            selectLoadedContent,
        };
    },
});
